export default __webpack_public_path__ + "static/media/Thoothukudi-Nazarath.5d892494.png";